const sendEvent = (eventId, data = {}) => {
  const event = {
    id: `guuru::${eventId}`,
    data,
  };
  window.parent.postMessage(JSON.stringify(event), '*');
};

export default sendEvent;
